import { render, staticRenderFns } from "./store-group-max-up-down-panel.vue?vue&type=template&id=451c7b5d&scoped=true"
import script from "./store-group-max-up-down-panel.vue?vue&type=script&lang=js"
export * from "./store-group-max-up-down-panel.vue?vue&type=script&lang=js"
import style0 from "./store-group-max-up-down-panel.vue?vue&type=style&index=0&id=451c7b5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451c7b5d",
  null
  
)

export default component.exports